import { createFileRoute } from "@tanstack/react-router";

import { DropViewer } from "../features/drop/DropViewer";

/** The viewer canvas, addressed by its mounts. `/<join-code>` reaches the same surface. */
export const Route = createFileRoute("/drop/viewer/$dropMount/$padMount/$emoteMount")({
  component: ViewerCanvas,
});

function ViewerCanvas() {
  const { dropMount, padMount, emoteMount } = Route.useParams();
  return <DropViewer dropMount={dropMount} padMount={padMount} emoteMount={emoteMount} />;
}
